import { TextField } from "@mui/material";
import React from "react";

const ApproveMessage = ({ commentInput, handleCommentInput }) => {
  return (
    <div>
      <p>Please enter a comment for approval</p>
      <TextField
        label="Approve Comments"
        multiline
        maxRows={5}
        value={commentInput}
        onChange={handleCommentInput}
        sx={{
          "& .MuiOutlinedInput-root": {
            color: "#000",
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--main-theme-color) !important",
              },
            },
          },
          "& .MuiInputLabel-outlined": {
            "&.Mui-focused": {
              color: "var(--main-theme-color) !important",
            },
          },
        }}
      />
    </div>
  );
};

export default ApproveMessage;
